import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getPanoramaNodeById(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_STREET_VIEW_PANORAMA_NODE_BY_ID_REQUEST,
			payload: { loading: true }
		});

		const response = await API.panorama_nodes.getPanoramaNodeById(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_STREET_VIEW_PANORAMA_NODE_BY_ID_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { panorama_node } = response.data;

		dispatch({
			type: ActionTypes.GET_STREET_VIEW_PANORAMA_NODE_BY_ID_SUCCESS,
			payload: {
				loading: false,
				panorama_node
			}
		});
	};
}

export function resetMeta() {
	return async dispatch =>
		dispatch({ type: ActionTypes.RESET_STREET_VIEW_META });
}

export function resetPage() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_STREET_VIEW_PAGE });
	};
}
